import React, { useEffect, useState } from "react";
import "./SenerioRequest.scss";
import {
  Button,
  toastEmitter,
} from "@anchor/react-components/dist/lib/components";

import CardList, { CardItem } from "./Components/SimulationScenarioCard";
import { appRoles } from "../../utils/Constants";
import { getAPI, postAPI } from "../../Services/APIservices";
import { RunModel, filterModel, Filters, listModel } from "./Model";
import CreateSenerio from "./CreateSenerio";

const SenerioRequest = () => {
  const [simulationData, setSimulationData] = useState<RunModel[]>([]);
  const [mainData, setMainData] = useState<RunModel[]>([]);
  const [filterResponse, setFilterResponse] = useState<filterModel>();
  const [optimizationType, setOptimizationType] = useState<listModel[]>([]);
  const [idleVessels, setIdleVessels] = useState<listModel[]>([]);
  const [isSenerioModalOpen, setIsSenerioModalOpen] = useState(false);
  const [cargoDirectionType, setcargoDirectionType] = useState<listModel[]>([]);
  const [filters, setFilters] = useState<Filters>({
    createdBy: [],
    runDate: { startDate: null, endDate: null },
    status: [],
  });
  const [isLoad, setIsLoad] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [cardData, setCardData] = useState<CardItem[]>([]);
  const [selectedCard, setSelectedCard] = useState<CardItem | undefined>(
    undefined,
  );
  const userRole = sessionStorage.getItem("userRole");

  const handleCardData = async () => {
    const response = await getAPI(
      "simulation-api/simulation/GetAllModuleTriggerScenariosAsync",
    );
    if (response) {
      setCardData(response);
    }
  };

  const handleEditClick = (item: CardItem) => {
    setSelectedCard(item);
    setIsSenerioModalOpen(true);
  };

  const getFilterResponse = async () => {
    const response = await getAPI(
      "simulation-api/simulation/GetSimulationRequestFiltersAsync",
    );
    setFilterResponse(response);
  };

  const getOptimizationTypes = async () => {
    const response = await getAPI(
      "simulation-api/simulation/GetAllOptimizationTypes",
    );
    if (response) {
      setOptimizationType(response);
    }
  };

  const getIdleVesselList = async () => {
    const response = await getAPI("simulation-api/simulation/GetIdleVessels");
    if (response) {
      setIdleVessels(response);
    }
  };

  const GetAllCargoDirection = async () => {
    const response = await getAPI(
      "simulation-api/simulation/GetAllCargoDirection",
    );
    if (response) {
      setcargoDirectionType(response);
    }
  };

  useEffect(() => {
    // handleCardData();
    getFilterResponse();
    getOptimizationTypes();
    getIdleVesselList();
    GetAllCargoDirection();
  }, []);

  const handleScenarioCreated = () => {
    setIsSenerioModalOpen(false);
    handleCardData();
  };

  return (
    <div className="simulation-section p-3">
      <h1 className="header-text">Service Scenarios</h1>

      {userRole === appRoles.DeploymentUser && (
        <div className="senerio-button">
          <Button
            appearance="default"
            id="btnCreateSenerio"
            justifyItems="center"
            label="Create new scenario"
            name="CreateSenerio"
            fit="small"
            onClick={() => {
              setSelectedCard(undefined);
              setIsSenerioModalOpen(true);
            }}
            variant="primary"
          />
        </div>
      )}

      <CardList
        handleGeneratedData={handleCardData}
        cardData={cardData}
        onEditClick={handleEditClick}
      />

      <CreateSenerio
        isOpen={isSenerioModalOpen}
        dropDownData={cargoDirectionType}
        onClose={() => setIsSenerioModalOpen(false)}
        onSuccess={handleScenarioCreated} //
        existingData={selectedCard}
      />
    </div>
  );
};

export default SenerioRequest;
